import React from 'react';
import { Link } from 'react-router-dom';
import { publicAssetPath } from '../lib/publicAsset';

function FooterContactIcon({ type }) {
  const common = {
    viewBox: '0 0 24 24',
    width: '1.2em',
    height: '1.2em',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: '1.8',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': 'true',
    focusable: 'false',
  };

  if (type === 'instagram') {
    return (
      <svg {...common} viewBox="0 0 24 24">
        <rect x="3.25" y="3.25" width="17.5" height="17.5" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.4" cy="6.7" r="0.7" fill="currentColor" stroke="none" />
      </svg>
    );
  }

  if (type === 'phone') {
    return (
      <svg {...common}>
        <path d="M7.2 4.2l2.2-.7 2 4.3-1.6 1.3a14.2 14.2 0 0 0 5.1 5.1l1.3-1.6 4.3 2-.7 2.2a2.2 2.2 0 0 1-2.4 1.5A15.9 15.9 0 0 1 5.7 6.6a2.2 2.2 0 0 1 1.5-2.4Z" />
      </svg>
    );
  }

  return (
    <svg {...common}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m4 7 8 6 8-6" />
    </svg>
  );
}

export default function Footer() {
  return (
    <footer className="site-footer mt-5 py-3">
      <div className="container">
        <div className="site-footer-main">
          <div className="site-footer-brand">
            <img
              src={publicAssetPath('web_logo-cropped.png')}
              alt="Hunar logo"
              className="site-footer-brand-logo"
              style={{ height: '44px', width: 'auto', objectFit: 'contain' }}
            />
            <Link className="site-footer-sell-link" to="/sell-on-hunar">Sell on Hunar</Link>
          </div>
          <div className="site-footer-socials d-flex align-items-center gap-2" aria-label="Contact Hunar">
            <a
              className="site-footer-social-link"
              href="https://www.instagram.com/hunar.nextgenaischool.in?utm_source=ig_web_button_share_sheet&igsi=ZDNlZDc0MzIxNw=="
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Hunar on Instagram"
              title="Instagram"
            >
              <FooterContactIcon type="instagram" />
            </a>
            <a
              className="site-footer-social-link"
              href="tel:+919811096411"
              aria-label="Call Hunar at +91 98110 96411"
              title="+91 98110 96411"
            >
              <FooterContactIcon type="phone" />
            </a>
            <a
              className="site-footer-social-link"
              href="mailto:lakshaychawla13@gmail.com"
              aria-label="Email Hunar at lakshaychawla13@gmail.com"
              title="lakshaychawla13@gmail.com"
            >
              <FooterContactIcon type="email" />
            </a>
          </div>
        </div>

        <hr className="my-2" />

        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center small text-muted">
          <span>© {new Date().getFullYear()} Hunar. All rights reserved.</span>
          <span className="d-flex flex-wrap justify-content-center gap-3">
            <Link to="/reviews" className="text-reset text-decoration-none">Reviews</Link>
            <Link to="/returns" className="text-reset text-decoration-none">No-refund policy</Link>
            <span>Powered by <a href="https://nextgenaischool.in/" target="_blank" rel="noopener noreferrer" className="text-reset text-decoration-none">NextGen AI School</a></span>
          </span>
        </div>
      </div>
    </footer>
  );
}
